import { Component, OnInit, inject } from '@angular/core';
import { BrandService } from './core/services/brand.service';
import { MixpanelService } from './core/services/mixpanel.service';
import { AuthService } from './core/services/auth.service';
import { environment } from 'environments/environment';
import { MixpanelEvent } from './core/constants/mixpanel-events.const';
import { FirebaseMessagingService } from './core/services/firebase-messaging.service';
import { NotificacaoService } from './core/services/notificacao.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit {
  private brandService = inject(BrandService);
  private mixpanelService = inject(MixpanelService);
  private authService = inject(AuthService);
  private firebaseService = inject(FirebaseMessagingService);
  private notificacaoService = inject(NotificacaoService);

  ngOnInit() {
    this.brandService.initializeBrand();
    this.initializeMixpanel();
    this.setupAuthListener();
  }

  private initializeMixpanel(): void {
    this.mixpanelService.track(MixpanelEvent.APP_INICIALIZADO, {
      ambiente: environment.production ? 'producao' : 'desenvolvimento',
    });

    this.mixpanelService.setSuperProperties({
      app_version: '1.17.3',
      platform: 'web',
      environment: environment.production ? 'production' : 'development',
    });
  }

  private setupAuthListener(): void {
    this.authService.currentUser$.subscribe(user => {
      if (user) {
        this.initializeNotifications();
      }
    });
  }

  private initializeNotifications(): void {
    this.notificacaoService.listar().subscribe({
      error: err => {
        console.error('[App] Erro ao carregar notificações:', err);
      },
    });

    this.firebaseService.initializeForAuthenticatedUser().catch(err => {
      console.error('[App] Erro ao configurar notificações:', err);
    });
  }
}
